<template lang="pug">
.container
  .row
    .col-md-4.pe-6
      .widget.mb-5
        h2.h4.text-black.mb-3 ค้นหาคำสำคัญ
        form
          input.form-control(
            v-model='form.keyword',
            type='search',
            placeholder='พิมพ์คำค้นหา',
            @input='fetchNews'
          )

      .widget.mb-5
        h2.h4.text-black.mb-4 หน่วยงาน

        ul.list-unstyled
          li
            router-link.link-dark.text-decoration-none.d-flex.align-items-start(
              :to='{ path: "/", query: { category: $route.query.category } }',
              :class='{ "is-active": !$route.query.agency }'
            ) 
              icon-lightning.flex-shrink.fill-secondary.me-2
              | ทั้งหมด
          li.d-flex.align-items-start(
            v-for='agency in agencies',
            :key='agency.id'
          )
            router-link.link-dark.text-decoration-none.d-flex.align-items-start(
              :to='{ path: "/", query: { agency: decodeURIComponent(agency.slug), category: $route.query.category } }',
              :class='{ "is-active": $route.query.agency === decodeURIComponent(agency.slug) }'
            ) 
              icon-lightning.flex-shrink.fill-secondary.me-2
              | {{ agency.name }}

      .widget.mb-5
        h2.h4.text-black.mb-4 หมวดหมู่

        ul.list-unstyled
          li
            router-link.link-dark.text-decoration-none.d-flex.align-items-start(
              :to='{ path: "/", query: { agency: $route.query.agency } }',
              :class='{ "is-active": !$route.query.category }'
            ) 
              icon-lightning.flex-shrink-0.fill-secondary.me-2
              | ทั้งหมด

          li(v-for='category in categories', :key='category.id')
            router-link.link-dark.text-decoration-none.d-flex.align-items-start(
              :to='{ path: "/", query: { agency: $route.query.agency, category: decodeURIComponent(category.slug) } }',
              :class='{ "is-active": $route.query.category === decodeURIComponent(category.slug) }'
            ) 
              icon-lightning.flex-shrink-0.fill-secondary.me-2
              | {{ category.name }}
    .col-md-8.content(
      :data-layout='layout',
      :class='{ "is-loading": isLoading }'
    )
      template(v-if='news.length')
        .d-flex.justify-content-end.pb-3
          span.switch-layout.list(
            role='button',
            @click='layout = "list"',
            :class='{ "is-active": layout === "list" }',
            data-bs-toggle='tooltip',
            data-bs-placement='top',
            title='แสดงแบบรายการ'
          )
            icon-list
          span.switch-layout.grid.ps-2(
            role='button',
            @click='layout = "grid"',
            :class='{ "is-active": layout === "grid" }',
            data-bs-toggle='tooltip',
            data-bs-placement='top',
            title='แสดงแบบตาราง'
          )
            icon-grid
        .row.gy-5
          div(
            v-for='item in news',
            :key='item.id',
            :class='{ "col-md-6": layout === "grid", "col-md-12": layout === "list" }'
          )
            news-item(v-if='layout === "grid"', :item='item')
            news-item-list(v-else, :item='item')
      template(v-else)
        .p-8.text-center.bg-light.text-secondary(v-if='isLoaded') ไม่พบข้อมูล
</template>

<script>
import axios from 'axios'
import NewsItem from '../components/NewsItem.vue'
import NewsItemList from '../components/NewsItemList.vue'
import IconGrid from '../components/icons/Grid.vue'
import IconList from '../components/icons/List.vue'
import IconLightning from '../components/icons/Lightning.vue'
export default {
  components: { NewsItem, NewsItemList, IconGrid, IconList, IconLightning },
  data() {
    return {
      isLoading: false,
      isLoaded: false,
      layout: 'grid',
      title: '',
      news: [],
      agencies: [],
      categories: [],
      form: {},
      meta: {
        total: 0,
      },
      page: 1,
    }
  },

  watch: {
    $route() {
      this.fetchNews()
    },
  },

  created() {
    this.fetchNews()
    this.fetchAgencies()
    this.fetchCategories()
  },

  methods: {
    fetchAgencies() {
      axios.get(`${PEA.api.url}wp/v2/news_agency`, {}).then(({ data }) => {
        this.agencies = data
      })
    },

    fetchCategories() {
      axios.get(`${PEA.api.url}wp/v2/news_cat`, {}).then(({ data }) => {
        this.categories = data
      })
    },

    fetchNews() {
      this.isLoading = true
      axios
        .get(`${PEA.api.url}v1/news`, {
          params: {
            keyword: this.form.keyword,
            agency: this.$route.query.agency,
            category: this.$route.query.category,
          },
        })
        .then(({ data }) => {
          this.news = data.data
          this.isLoading = false
          setTimeout(() => {
            this.isLoaded = true
          }, 400)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.widget {
  h2 {
    &::after {
      width: 2.5rem;
      height: 0.25rem;
      background: var(--bs-primary);
      border-radius: 0.25rem;
      display: block;
      content: '';
    }
  }

  svg {
    width: 28px;
    height: auto;
    opacity: 0;
    transition: 0.3s;
  }

  a.is-active {
    svg {
      opacity: 1;
    }
  }

  li {
    margin-bottom: 10px;
  }

  .form-control {
    border: none;
    background: #fff9ff;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

.switch-layout {
  &.is-active {
    svg {
      fill: var(--bs-primary);
    }
  }
}

.content {
  transition: opacity 0.3s;

  &.is-loading {
    opacity: 0.5;
  }
}
</style>